module.exports = __webpack_public_path__ + "static/media/playo-logo.2b6ef6f4.svg";